import { ReactEditor } from 'slate-react';
import isUrl from 'is-url';

import { wrapLink } from './transform/insertLinkAtSelection';
import { isExpanded } from '../../../../slatePlugins/common/queries/isExpanded';

export const withHyperLinkPlugin =
  (options?) =>
  <T extends ReactEditor>(editor: T) => {
    const { insertText } = editor;

    editor.insertText = (text) => {
      if (text && isUrl(text) && isExpanded(editor.selection)) {
        wrapLink(editor, {
          url: text,
          linkSettings: [],
        });
      } else {
        insertText(text);
      }
    };

    return editor;
  };
